<template>
  <div class="home bg-grey">
    <NavbarMain />
    <div class="bg-warning px-2 py-2 text-right d-flex" v-if="product.state != 3">
      <div class="form-check ml-auto">
        <span
          class="btn btn-danger"
          v-if="product.state == 1"
          @click="changeStatusProduct(0)"
        >Inabilitar publicacion</span>
        <span class="btn btn-success" v-else @click="changeStatusProduct(1)">Activar publicacion</span>
        <span class="ml-2 btn btn-danger d-none" @click="deleteProduct()">Eliminar publicacion</span>
      </div>
    </div>
    <div class="alert alert-danger mt-2" role="alert" v-if="product.msgCancel">{{product.msgCancel}}</div>
    <div class="container bg-white mt-5 p-3 border-8 shadow-sm">
      <div class="row mt-5">
        <div class="col-xl-6 col-sm-12 col-md-5">
          <div
            class="img-fluid img-thumbnail img-squared mr-4 shadow-sm"
            :style="'background-image: url('+url+'public/images/products/'+product.images[imageSelected]+'); height: 26.5em'"
          ></div>
        </div>
        <div class="col-xl-6 col-sm-12 col-md-7 pt-5">
          <h4 class="font-weight-bold">{{product.name}}</h4>
          <h4 class="pt-2 font-weight-bold text-danger">
            $SC {{sacoinsNewPrice}}
            <div class="mb-3 d-inline">
              <span class="text-muted">
                <small>({{product.currency == 'USA' ? 'USD' : product.currency }}$ {{currencyNewPrice}})</small>
              </span>
              <small class="pl-2">[CRR: {{product.category.crr}}%]</small>
            </div>
            <div :class="product.discount ? 'd-inline' : 'd-none'">
              <span class="badge badge-success ml-3">{{product.discount}}% off</span>
              <div class="old-price">
                $SC {{sacoinsOldPrice}}
                <div class="d-inline">
                  <span class="text-muted">
                    <small class="my-auto">({{product.currency == 'USA' ? 'USD' : product.currency }}$ {{currencyOldPrice}})</small>
                  </span>
                </div>
              </div>
            </div>
          </h4>
          <p>
            Categoria:
            <span v-if="product.category">
              <router-link
                :to="{name: 'ProductsByCategory', params: {category: product.category.name.replace(/\s/g,'-')}}"
              >{{product.category.name}}</router-link>
            </span>
            <span v-else>-</span>
          </p>

          <p>
            Vendedor:
            <b>{{product.sellerId ? product.sellerId.username : ''}}</b>
          </p>
          <div>
            <p v-if="product.sellerPlaces.length > 0 && product.CityOfSale == '' ">
              Envíos a:
              <span
                v-for="country in listCountries"
                :key="country"
                class="badge badge-dark mr-1 p-2"
              >{{country}}</span>
            </p>
            <p v-if="product.sellerPlaces.length == 1 && product.CityOfSale">
              Ciudad de venta:
              <span
                class="badge badge-dark mr-1 p-2"
              >{{product.CityOfSale}} - {{listCountries[0]}}</span>
            <span class="badge badge-info mr-1 p-2" v-if="product.shippingType == 2">Recoger en domicilio</span>
            <span class="badge badge-info mr-1 p-2" v-else>Envío a domicilio</span>
            </p>
            <p v-if="product.sellerPlaces.length == 0">
              Envíos a:
              <span class="badge badge-dark mr-1 p-2" v-if="product.shippingType != 2">Todo el mundo!</span>
            </p>
          </div>
          <p>
            Cantidad:
            <input
              type="number"
              class="form-control mr-3"
              id="amount-input"
              :max="product.amount"
              min="1"
              value="1"
            />
            <span class="text-muted">(Disponible: {{product.amount}})</span>
          </p>
          <p v-for="(option, i) in product.options" :key="`opt-${i}`">
            {{option.form.name}}:
            <select class="form-control d-inline-block w-auto">
              <option v-for="(opt, j) in option.options" :key="`subOpt${i}-${j}`">{{opt}}</option>
            </select>
          </p>
          <div class="row">
            <div class="col-6">
              <span class="btn btn-block btn-success text-uppercase">comprar ahora</span>
            </div>
            <div class="col-6">
              <span class="btn btn-block btn-treid text-uppercase">agregar a carrito</span>
            </div>
          </div>
          <div class="row pt-5">
            <div
              v-for="(image, index) in product.images"
              v-bind:key="index"
              class="img-fluid img-thumbnail img-squared d-inline mr-4 cursor-pointer"
              :style="'background-image: url('+url+'public/images/products/'+image+'); height: 6em;width: 6em'"
              @mouseover="imageSelected = index"
              :class="imageSelected == index ? 'border border-danger' : ''"
            ></div>
          </div>
        </div>
      </div>
      <div class="mt-5" v-if="product.videoYT">
        <div class="embed-responsive embed-responsive-16by9">
          <iframe
            width="560"
            height="315"
            :src="'https://www.youtube.com/embed/'+product.videoYT"
            frameborder="0"
            allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
            allowfullscreen
          ></iframe>
        </div>
      </div>
       <div class="description pl-5 pr-5 pb-5">
        <h3 class="mt-5">Descripción</h3>
        <p style="white-space:pre-wrap;">{{product.description}}</p>
        <h3 class="mt-5" v-if="product.specs.length">Especificaciones</h3>
        <div class="row">
          <div class="col-md-6 col-sm-12" v-for="spec in product.specs" :key="spec._id">
            <div v-if="spec.form != null && spec.value">
              <h5>{{spec.form.name}}:</h5>
              <p style="white-space:pre-wrap;">{{spec.value}}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <ModalSuccess v-on:close="closeModal" title="Producto actualizado" :description="`El producto ha sido ${product.state == 1 ? 'activado' : 'inhabilitado'} con exito`" :visible="showModal" />
  </div>
</template>

<script>
import NavbarMain from "@/components/NavbarMain.vue";
import ModalSuccess from "../../components/modals/ModalSuccess.vue"
import Api from "../../tools/Api2";
import { mapState } from "vuex";
import Configs from "@/configs/configs";
import countries from "@/configs/countries";
import calc from "@/tools/calc.js";

export default {
  name: "AdminProduct",
  data() {
    return {
      showModal: false,
      imageSelected: 0,
      listCountries: [],
      product: {
        specs: [],
        sellerPlaceWorld: false,
        sellerPlaces: [],
        CityOfSale: "",
        category: {
          name: "_",
        },
        state: -1,
        description: "",
        discount: "",
        name: "",
        currency: 'USA',
        price: "",
        sellerId: {
          username: "",
        },
        images: ["blank.png"],
      },
      url: Configs.API.BASE,
    };
  },
  components: {
    NavbarMain,
    ModalSuccess
  },
  methods: {
    closeModal(){
      this.$router.push({name: "AdminProducts"})
    },
    deleteProduct() {
      Api("product").delete(this.product._id).then( () => {
        this.$router.push(`/admin/products`);
      })
    },
    changeStatusProduct(state) {
      Api("product").patch(this.product._id, {state}).then( res => {
        if(!res.error){
        this.product.state = state;
        this.showModal = true;
        }else{
          alert(res.message)
        }
      })
    },
    productSCPrice(price, change){
      if (price || change) {
        return calc.price.toSacoin(price, this.changes[`${change ? change : 'USA'}-Venta`])
      }else{
        return 0
      }
    },
    getProductPrice(price){
      return calc.price.get(price)
    }
  },
  created: async function () {
    window.scrollTo(0, 0);
    Api("product").get(this.$route.params.id).then( res => {
      res.product.sellerPlaces = res.product.sellerPlaces.filter((e) => e != "");
      this.listCountries = res.product.sellerPlaces.map((e) =>
        countries.find((f) => f.iso3 == e)
          ? countries.find((f) => f.iso3 == e).nombre
          : ""
      );
      if (!res.product.images.length) {
        res.product.images = ["blank.png"];
      }
      const specs = res.product.specs.filter((e) => e.form != null && e.value != "");
      const options = res.product.specs.filter((e) => e.form != null && e.value == "");
      this.product = { ...res.product, specs, options };
    })
  },
  computed: {
    ...mapState(["auth", "changes"]),
    sacoinsNewPrice() {
      const currency =  this.product.currency == 'BTC' ? this.product.currency : (`${this.product.currency ? this.product.currency : 'USA'}-Venta`);
      if(currency && this.changes)
        return calc.price.toSacoinWDiscount(this.product.price, this.changes[currency], this.product.discount)
      return 0;
    },
    currencyNewPrice() {
      return calc.price.discount(this.product.price, this.product.discount)
    },
    sacoinsOldPrice() {
       const currency =  this.product.currency == 'BTC' ? this.product.currency : (`${this.product.currency ? this.product.currency : 'USA'}-Venta`)
      if(currency && this.changes)
        return calc.price.toSacoin(this.product.price, this.changes[currency]);
      return 0;
    },
    currencyOldPrice() {
      return calc.price.get(this.product.price)
    },
  },
};
</script>

<style scoped>
#amount-input {
  width: 4em;
  display: inline;
}

/* number inputs with arrows always visible */
input[type="number"]::-webkit-inner-spin-button,
input[type="number"]::-webkit-outer-spin-button {
  opacity: 1;
}

.old-price {
  text-decoration: line-through;
  font-size: 0.8em;
}

.old-price div {
  margin-left: 0.5em;
  text-decoration: line-through;
  text-decoration-color: grey;
  font-size: 0.8em;
}
</style>